import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideDirective } from "../../directives/outside.directive";
import { FormModalComponent } from "../form-modal/form-modal.component";
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
interface DropdownItem {
  id: string;
  name: string;
}
@Component({
  selector: 'app-select-dropdown',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule, FormModalComponent],
  templateUrl: './select-dropdown.component.html',
  styleUrl: './select-dropdown.component.scss'
})
export class SelectDropdownComponent implements OnInit,OnChanges {
  itemnotmatch: boolean = true;
  @Input() icon: boolean | string = false;
  @Input() iconName: string = '';

  get hasIcon(): boolean {
    return !!(this.icon === true ||
              (typeof this.icon === 'string' && this.icon.trim() !== '' && this.icon !== 'false') ||
              this.iconName);
  }

  get resolvedIconClass(): string {
    const ic = (typeof this.icon === 'string' && this.icon !== 'true' && this.icon !== 'false'
      ? this.icon
      : this.iconName || '').trim();
    if (!ic) return 'fa fa-list';
    if (ic.startsWith('fa-') && !ic.includes(' ')) return `fa ${ic}`;
    return ic;
  }

ngOnInit(): void {
  this.addmodalId = `addModal-${this.id}`;

  if (this.keyRequired === true) {
    setTimeout(() => {
      this.requiredKey.emit({ id: this.id, required: this.keyRequired });
    }, 300);
  }

  // Initialize existing value if already available
  this.setExistingValue();
}

ngOnChanges(changes: SimpleChanges): void {
  if (changes['options']) {
    this.internalOptions = this.options.list || [];

    // 🟢 Handle case where existingValue becomes valid after options load
    if (this.existingValue) {
      this.setExistingValue();
    }
  }

  if (changes['existingValue'] && this.existingValue) {
    // 🟢 Handle case where existingValue arrives later
    this.setExistingValue();
  }

  if (changes['id']) {
    this.addmodalId = `addModal-${this.id}`;
  }

  if (this.checkValidation === true && !this.selectedValue?.trim()) {
    this.showRequiredError = true;
  }
}


private setExistingValue(): void {
  if (this.options?.list?.some(item => item.name === this.existingValue)) {
    this.searchTerm = this.existingValue;
    this.selectedValue = this.existingValue;
    this.selecteditem.emit({ id: this.id, value: this.selectedValue });
  } else {
    console.warn(`No matching option found for existingValue: ${this.existingValue}`);
  }
}



@Output() requiredKey = new EventEmitter<{id:string,required:boolean}>()
@Input() checkValidation:boolean = false
@Input() placeholder : string =''
@Input() header : string =''
@Input() options: { list: { id: string; name: string }[] } = { list: [] };
@Input() keyRequired = false;
@Input() existingValue : string = ''
@Output() selecteditem = new EventEmitter<{id:string,value:string}>()
@Input() id :string = ""
@Output() reloadOptions = new EventEmitter<string>()
@Input() ShowEdit:boolean = false
@Input() ShowAdd:boolean = false

@Input() APIUrl:string =''
addmodalId:string =''
searchTerm = '';
selectedItem: string = '';
selectedItemId:string = '';
showRequiredError = false;
internalOptions: DropdownItem[] = []; // converted array for filtering
selectedValue: string = ''; // single selected value
constructor(private http: HttpClient){
  
}
get filteredItems(): DropdownItem[] {
  if (!this.searchTerm.trim()) {
    return this.internalOptions;
  }

  const lowerSearchTerm = this.searchTerm.toLowerCase();
  const matchedItems = this.internalOptions.filter(opt =>
    opt.name.toLowerCase().includes(lowerSearchTerm)
  );

  if (matchedItems.length === 0) {
    this.showRequiredError = true; // ✅ mark error if nothing matches
    return [{ id: 'none', name: 'Item does not exist' }];
  }

  this.showRequiredError = false; // ✅ reset error when valid items exist
  return matchedItems;
}
log(){
  console.log(this.APIUrl);
  console.log(this.addmodalId);
}
itemExists(item: DropdownItem): boolean {
  return this.internalOptions.some(opt => opt.id === item.id);
}


onDropdownOpenChange(isOpen: boolean) {
  // When dropdown closes, check if required and no value
  if (!isOpen && this.keyRequired && !this.selectedValue.trim()) {
    this.showRequiredError = true;
  }
}
onInputChange(event: Event) {
  const input = event.target as HTMLInputElement;
  this.searchTerm = input.value;
  this.selectedValue = input.value.trim();

  if (this.keyRequired && !this.selectedValue) {
    this.showRequiredError = true;
  } else {
    this.showRequiredError = false;
  }
}
selectOption(item: DropdownItem) {
  if (item.id === 'none') return; // ignore "Item does not exist"

  this.searchTerm = item.name;
  this.selectedValue = item.name;
  this.showRequiredError = false;

  this.selecteditem.emit({ id: this.id, value: this.selectedValue });
}


Additem(payload: string) {
  console.log('📩 Adding item:', payload);
  const apiURL = environment.apiURL + this.APIUrl;

  this.http.post<any>(apiURL, { name: payload }).subscribe({
    next: (res) => {
      console.log('✅ Item added:', res);
      // refresh options after add
      this.reloadOptions.emit(this.id);
    },
    error: (err) => {
      console.error('❌ Failed to add item', err);
    }
  });
}

  openEditModal(item: string,itemId:string): void {
    this.selectedItem = item; // assign value to input
    this.selectedItemId = itemId
    console.log('Edit button clicked');  
  }

  editItem(item: string) {
    const apiURL = environment.apiURL + this.APIUrl;
    console.log(item);
    
    this.http.put<any>(apiURL, { id: this.selectedItemId, name: item }).subscribe({
      next: (res) => {
        console.log('✅ Item added:', res);
        this.reloadOptions.emit(this.id);

      },
      error: (err) => {
        console.error('❌ Failed to add item', err);
      }
    });
  }




}
